import React, {
    useState,
    useEffect,
    useRef
} from 'react';

import Card from '@material-ui/core/Card';
// import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { api_bd, api_bd_nr } from '../services/Api'

const { cor_tipos_situacao } = require('../config.json')

function CardsContadores({ set_filtro_situacao, department }) {

    const [abortController] = useState(() => new AbortController())

    const intervalRef = useRef(null);

    const [qtd_list_chamados, set_qtd_list_chamados] = useState([])
    const styleCardsContent = {
        marginTop: -8,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 100,
        maxHeight: 100
    }

    const style_image_loading = {
        width: 100,
        marginLeft: 0
    }


    const load_cards_counter_data = (setData, department) => {
        // api_bd.get(`/tickets/contador${department ? '?d=' + encodeURI(department) : ''}`, {signal: abortController.signal}).then(resp => {
        api_bd_nr.get(`/tickets/counters${department ? '?d=' + encodeURI(department) : ''}`, {signal: abortController.signal}).then(resp => {
            if (resp.data.length > 0) {
                setData(resp.data)
            } else {
                setData([1])
            }
        })
    }

    useEffect(() => {
        load_cards_counter_data(set_qtd_list_chamados, department)


        intervalRef.current = setInterval(async () => {
            load_cards_counter_data(set_qtd_list_chamados, department)
        }, 15000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            // abortController.abort()
        };

    }, [])


    useEffect(() => {
        load_cards_counter_data(set_qtd_list_chamados, department)
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [department])


    return (
        <div className="container_cards_contadores">
            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['novo'],
                    borderTop: `8px solid ${cor_tipos_situacao['novo']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['novo']}`,
                    borderRadius: '40px 0px 30px 0px'

                }}
                onClick={() => {
                    localStorage.setItem('filtro_situacao', 'novos_e_atribuidos')
                    set_filtro_situacao('novos_e_atribuidos')
                }}>
                <CardContent style={styleCardsContent}>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>{qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : (qtd_list_chamados.length === 1 && qtd_list_chamados[0] === 1) ? 0 : qtd_list_chamados.filter(el => el.situacao.titulo.match(/novo|atribuido/i)).length}</div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Novos e atribuidos</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['em_tratativa'],
                    borderTop: `8px solid ${cor_tipos_situacao['em_tratativa']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['em_tratativa']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {
                    localStorage.setItem('filtro_situacao', 'em_tratativa')
                    set_filtro_situacao('em_tratativa')
                }}>
                <CardContent style={styleCardsContent}>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>{qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : (qtd_list_chamados.length === 1 && qtd_list_chamados[0] === 1) ? 0 : qtd_list_chamados.filter(el => el.situacao.titulo.match(/em_tratativa/i)).length}</div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Em tratativa</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['em_execucao'],
                    borderTop: `8px solid ${cor_tipos_situacao['em_execucao']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['em_execucao']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {
                    localStorage.setItem('filtro_situacao', 'em_execucao')
                    set_filtro_situacao('em_execucao')
                }}>
                <CardContent style={styleCardsContent}>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>{qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : (qtd_list_chamados.length === 1 && qtd_list_chamados[0] === 1) ? 0 : qtd_list_chamados.filter(el => el.situacao.titulo.match(/em_execucao/i)).length}</div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Em Execução</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['pendente_cliente'],
                    borderTop: `8px solid ${cor_tipos_situacao['pendente_cliente']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['pendente_cliente']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {
                    localStorage.setItem('filtro_situacao', 'pendente')
                    set_filtro_situacao('pendente')
                }}>
                <CardContent style={styleCardsContent}>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>{qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : (qtd_list_chamados.length === 1 && qtd_list_chamados[0] === 1) ? 0 : qtd_list_chamados.filter(el => el.situacao.titulo.match(/pendente_|aguardando|follow_up/i)).length}</div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Pendentes</div>
                </CardContent>
            </Card>


            <Card className="card_contador_chamados"
                style={{
                    // backgroundColor: cor_tipos_situacao['janela_agendada'],
                    borderTop: `8px solid ${cor_tipos_situacao['janela_agendada']}`,
                    borderBottom: `8px solid ${cor_tipos_situacao['janela_agendada']}`,
                    borderRadius: '40px 0px 30px 0px'
                }}
                onClick={() => {
                    localStorage.setItem('filtro_situacao', 'janela_agendada')
                    set_filtro_situacao('janela_agendada')
                }}>
                <CardContent style={styleCardsContent}>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '3em' }}>{qtd_list_chamados.length === 0 ? <img style={style_image_loading} src="https://apisgi.intecsolutions.com.br/uploads/loading.webp" /> : (qtd_list_chamados.length === 1 && qtd_list_chamados[0] === 1) ? 0 : qtd_list_chamados.filter(el => el.situacao.titulo.match(/janela_agendada/i)).length}</div>
                    <div style={{ width: '100%', textAlign: 'center', fontSize: '1.3em' }}>Janela Agendada</div>
                </CardContent>
            </Card>

        </div>
    );
}

export default CardsContadores;